import http from './http';
import {API_BASE_URL} from '../config';

export default class TransationService {
  static getTransaction = (params) =>{
    const config={
      params
    }
    return http.get(`${API_BASE_URL}/v2/transaction`, config).then(res => res);
    
  }
}
